import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DataObjectGroups.translations.json';
import { NotFound } from '../NotFound';
import { DataObjectGroupDirectory } from './DataObjectGroupDirectory';
import { DataObjectGroupDetails } from './DataObjectGroupDetails';
import { DataObjectGroupBreadcrumbsData } from './DataObjectGroupBreadcrumbs';
import { DataObjectGroupCreate } from './DataObjectGroupCreate';
import { DataObjectGroupEdit } from './DataObjectGroupEdit';

export const { addTranslations, useTranslation, Translation } = i18nNsFactory(
  'data-object-groups-page'
);
addTranslations(translations);

export const DATA_OBJECT_GROUP_ROUTES = [
  {
    path: path.dataObjectGroupDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.data-object-groups')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <DataObjectGroupDirectory />,
      },
      {
        path: path.dataObjectGroupCreate,
        element: <DataObjectGroupCreate />,
        renderBreadcrumb: () => (
          <Translation>
            {(t) => t('breadcrumb.data-object-group-create')}
          </Translation>
        ),
      },
      {
        path: path.dataObjectGroupDetails,
        element: <DataObjectGroupDetails />,
        renderBreadcrumb: (data?: DataObjectGroupBreadcrumbsData) =>
          data ? (
            `${data.code} - ${data.name}`
          ) : (
            <Translation>
              {(t) => t('breadcrumb.data-object-group-details')}
            </Translation>
          ),
      },
      {
        path: path.dataObjectGroupEdit,
        renderBreadcrumb: () => (
          <Translation>
            {(t) => t('breadcrumb.data-object-group-edit')}
          </Translation>
        ),
        element: <DataObjectGroupEdit />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const DataObjectGroups: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, DATA_OBJECT_GROUP_ROUTES));
